"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _index = _interopRequireDefault(require("../mega-menu/index.sync"));

var _zod = require("zod");

var _UserContext = require("@insided/shared/services/UserContext");

var _globals = require("@insided/shared/utils/globals");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getCategoryId() {
  if (typeof window === 'undefined') {
    return null;
  }

  return (0, _insidedDataStorage.getInsidedData)('content').category.id;
}

var widgetName = 'header_navigation';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-header_navigation';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  items: _zod.z.array(_zod.z.object({
    key: _zod.z.string(),
    visibility: _zod.z.boolean(),
    name: _zod.z.string()
  })),
  logo: _zod.z.string(),
  productSharedVisibility: _zod.z.object({
    community: _zod.z.object({
      megaMenuVisible: _zod.z.boolean(),
      selectedItems: _zod.z.array(_zod.z.string())
    }),
    skilljar: _zod.z.object({
      megaMenuVisible: _zod.z.boolean(),
      selectedItems: _zod.z.array(_zod.z.string())
    })
  }).default({
    community: {
      megaMenuVisible: true,
      selectedItems: []
    },
    skilljar: {
      megaMenuVisible: true,
      selectedItems: []
    }
  })
}).default({
  items: [],
  logo: '',
  productSharedVisibility: {
    community: {
      megaMenuVisible: true,
      selectedItems: []
    },
    skilljar: {
      megaMenuVisible: true,
      selectedItems: []
    }
  }
});

exports.config = config;

var getDefaultItems = function getDefaultItems(props, modules) {
  var defaultItems = [{
    key: 'community',
    visibility: true,
    name: 'Community'
  }];

  if (modules.includes('knowledgeBase')) {
    defaultItems = defaultItems.concat({
      key: 'knowledgeBase',
      visibility: true,
      name: 'Knowledge Base'
    });
  }

  if (modules.includes('ideationV2')) {
    defaultItems = defaultItems.concat({
      key: 'ideation',
      visibility: true,
      name: 'Ideas',
      url: '/ideas'
    });
  }

  if (modules.includes('productUpdates')) {
    defaultItems = defaultItems.concat({
      key: 'productUpdates',
      visibility: true,
      name: 'Product Updates',
      url: '/product-updates'
    });
  }

  if (modules.includes('event')) {
    defaultItems = defaultItems.concat({
      key: 'event',
      visibility: true,
      name: 'Events',
      url: '/events'
    });
  }

  if (modules.includes('group') && props.groupCount) {
    defaultItems = defaultItems.concat({
      key: 'group',
      visibility: true,
      name: 'Groups',
      url: '/groups'
    });
  }

  return defaultItems;
};

var getItems = function getItems(props, modules) {
  var _props$items;

  var items = []; // Get base items (from props or defaults)

  if ((_props$items = props.items) !== null && _props$items !== void 0 && _props$items.length) {
    var groupIdx = props.items.findIndex(function (item) {
      return item.key === 'group';
    });

    if (groupIdx && !(modules.includes('group') && props.groupCount)) {
      var newItems = props.items.concat([]);
      newItems.splice(groupIdx, 1);
      items = newItems;
    } else {
      items = props.items;
    }
  } else {
    items = getDefaultItems(props, modules);
  } // Items are already filtered in the template (megaMenu/index.twig) based on productSharedVisibility
  // No need to filter again here - template handles all filtering logic at the entry point


  return items;
};

var WidgetHeaderNavigation = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(WidgetHeaderNavigation, _Component);

  var _super = _createSuper(WidgetHeaderNavigation);

  function WidgetHeaderNavigation() {
    (0, _classCallCheck2.default)(this, WidgetHeaderNavigation);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(WidgetHeaderNavigation, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return (0, _preact.h)(_UserContext.UserPermissionContext.Consumer, null, function (permissions) {
        return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
          var _getCategoryId;

          return (0, _preact.h)(_index.default, {
            items: getItems(props, modules),
            communityCategoriesV2: [],
            knowledgeBaseCategoriesV2: [],
            logo: props.logo || '',
            ssoLoginUrl: props.ssoLoginUrl,
            newTopicURL: props.newTopicURL,
            communityCustomerTitle: props.communityCustomerTitle,
            searchInfo: {
              isFederatedSalesforceSearch: props.isFederatedSalesforceSearch,
              isFederatedSkilljarSearch: props.isFederatedSkilljarSearch,
              isFederatedFreshdeskSearch: props.isFederatedFreshdeskSearch,
              category: (_getCategoryId = getCategoryId()) !== null && _getCategoryId !== void 0 ? _getCategoryId : undefined,
              isParentCategory: false // TODO implement this and isParentCategory when extending this feature to category page

            },
            permissions: {
              ideation: permissions.permissions.includes('forum.idea.view') || permissions.permissions.includes('forum-idea-all'),
              productUpdates: permissions.permissions.includes('forum.product.updates.view') || permissions.permissions.includes('forum-product-updates-all')
            },
            searchRevamp: props.searchRevamp,
            aiSearchSummary: props.aiSearchSummary,
            selectedTemplate: props.selectedTemplate,
            showAuthPage: props.showAuthPage,
            phrases: props.phrases
          });
        });
      });
    }
  }]);
  return WidgetHeaderNavigation;
}(_preact.Component);

exports.default = WidgetHeaderNavigation;